export default __webpack_public_path__ + "static/1.2-01ef03b63efcdd686d5a7b3c3e412c6b.webp";